export const header = [
    {
        "nombre": "INICIO",
        "link": "/"
    },
    {
        "nombre": "NOSOTROS",
        "link": "/nosotros"
    },
    {
        "nombre": "SERVICIOS",
        "link": "/servicios",
        "submenu": [
            {
                "nombre": "INDUSTRIALES",
                "link": "/servicios/industriales"
            },
            {
                "nombre": "RESIDENCIALES",
                "link": "/servicios/residenciales"
            },
            {
                "nombre": "COMERCIALES",
                "link": "/servicios/comerciales"
            }
        ]
    },
    {
        "nombre": "PROYECTOS",
        "link": "/proyectos"
    },
    {
        "nombre": "CONTACTO",
        "link": "/contacto"
    }
];

export const header_ing = [
    {
        "name": "HOME",
        "link": "/"
    },
    {
        "name": "ABOUT US",
        "link": "/nosotros"
    },
    {
        "name": "SERVICES",
        "link": "/servicios",
        "submenu": [
            {
                "name": "INDUSTRIAL",
                "link": "/servicios/industriales"
            },
            {
                "name": "RESIDENTIAL",
                "link": "/servicios/residenciales"
            },
            {
                "name": "COMMERCIAL",
                "link": "/servicios/comerciales"
            }
        ]
    },
    {
        "name": "PROJECTS",
        "link": "/proyectos"
    },
    {
        "name": "CONTACT",
        "link": "/contacto"
    }
];
